import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Honor from './views/Honor.vue'
import Tv from './views/Tv.vue'
import Tvcctv from './views/Tvcctv.vue'
import Tvbrtv from './views/Tvbrtv.vue'
import Noticle from './views/Noticle.vue'
import Media from './views/Media.vue'
import Anli from './views/Anli.vue'
import Team from './views/Team.vue'
import Teamlist from './views/Teamlist.vue'
import Search from "./views/Search.vue"

import Article from './views/Article.vue'

import Footer from '@/components/FooterView.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/honor/index.html',
      name: 'honor',
      component: Honor
    },
	{
	  path: '/honor/:biaoshi/:id.html',
	  name: 'honorhtml',
	  component: Article,
	  meta:{ parent: [ {path: '/honor/index.html', name: '冠领荣誉'}]}
	},
	{
	  path: '/tv/index.html',
	  name: 'tv',
	  component: Tv
	},
	{
	  path: '/tv/cctv/index.html',
	  name: 'cctv',
	  component: Tvcctv
	},
	{
	  path: '/tv/list/cctv.html',
	  name: 'cctv',
	  component: Tvcctv
	},
	{
	  path: '/tv/list/brtv.html',
	  name: 'brtv',
	  component: Tvbrtv
	},
	{
	  path: '/tv/:biaoshi/:id.html',
	  name: 'cctvhtml',
	  component: Article,
	  meta:{ parent: [ {path: '/tv/cctv/index.html', name: '央视普法'}]}
	},
	{
	  path: '/noticle/index.html',
	  name: 'noticle',
	  component: Noticle
	},
	{
	  path: '/noticle/:biaoshi/:id.html',
	  name: 'noticlehtml',
	  component: Article,
	  meta:{ parent: [ {path: '/noticle/index.html', name: '冠领公告'}]}
	},
	{
	  path: '/media/index.html',
	  name: 'media',
	  component: Media
	},
	{
	  path: '/media/:biaoshi/:id.html',
	  name: 'mediahtml',
	  component: Article,
	  meta:{ parent: [ {path: '/media/index.html', name: '媒体报道'}]}
	},
	{
	  path: '/anli/index.html',
	  name: 'anli',
	  component: Anli
	},
	{
	  path: '/anli/:biaoshi/:id.html',
	  name: 'anlihtml',
	  component: Article,
	  meta:{ parent: [ {path: '/anli/index.html', name: '胜诉案例'}]}
	},
	{
	  path: '/team/index.html',
	  name: 'team',
	  component: Team
	},
	{
	  path: '/team/list/:from.html',
	  name: 'team',
	  component: Teamlist
	},
	{
	  path: '/team/:biaoshi/:id.html',
	  name: 'teamhtml',
	  component: Article,
	  meta:{ parent: [ {path: '/team/index.html', name: '冠领团队'}]}
	},
	{
	  path: '/about.html',
	  name: 'abouthtml',
	  component: Article,
	  meta:{ parent: [ {path: '/about.html', name: '关于我们'}]}
	},
	{
	  path: '/search/index.html',
	  name: 'search',
	  component: Search,
	  meta:{ parent: [ {path: '/search/index.html', name: '搜索如下：'}]}
	}
  ]
})

router.beforeEach((to,from,next) => {
	// console.log(to)
	next()
})
export default router